import React from "react";
import DatagridUserActions from "../../actions/UserActions/DatagridUserActions";
import { SovosToolbarGroup } from "mosaic-react";
import { DefaultToolbar, StateInfoTab } from "colbi_web_ui/lib/components";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import theme from "mosaic-react/themes/index";
import { Refresh, Sync } from "mosaic-react-icons";
import { SovosIconButton, SovosToolbarActions } from "mosaic-react";
import { date } from "../../utils";

const AuditExecutionSummaryToolbar = ({ defaultToolbarProps, toolbarProps }) => {
    const { i18n, fetch, reload, params } = useGlobalValue();
    const { rowsSelected } = toolbarProps;
    const { section = "nc_audit_execution_summary" } = params || {};
    const key = Object.keys(fetch.status).filter((fetchKey) => fetchKey.includes(section));
    const nowInMilliseconds = Date.now();
    const lastReadTime = new Date(fetch.status[key]?.lastReadTime || nowInMilliseconds)
        .toISOString()
        .replace("T", " ")
        .substring(0, 19)
        .split(" ")[1];

    return (
        <SovosToolbarGroup sx={{ width: "100%" }}>
            <SovosToolbarGroup
                sx={{ flex: "1 1 auto", justifyContent: "flex-start", paddingRight: "10px" }}
            >
                <DatagridUserActions
                    count={rowsSelected?.length}
                    rowsSelectedIds={rowsSelected}
                    params={{ ...params, section }}
                />
                <StateInfoTab
                    sx={{
                        borderRight: `1px solid ${theme.palette.text.secondary};`,
                        paddingRight: "12px",
                        marginLeft: "12px",
                    }}
                    color={theme.palette.text.primary}
                    info=" "
                >
                    {i18n`nc_audit_execution_summary`}
                </StateInfoTab>
                <StateInfoTab
                    sx={{ paddingLeft: "8px" }}
                    icon={<Sync />}
                    color={theme.palette.text.secondary}
                    info={lastReadTime}
                >
                    {i18n`last_update`}: {date(nowInMilliseconds)},
                </StateInfoTab>
            </SovosToolbarGroup>
            <SovosToolbarGroup>
                <SovosToolbarActions>
                    <DefaultToolbar {...defaultToolbarProps} />
                    <SovosIconButton
                        tooltipText={i18n`Reload`}
                        position="end"
                        onClick={() => {
                            reload && reload();
                        }}
                        children={<Refresh />}
                    />
                </SovosToolbarActions>
            </SovosToolbarGroup>
        </SovosToolbarGroup>
    );
};

export default AuditExecutionSummaryToolbar;
